import { Component, OnDestroy, OnInit } from '@angular/core';
import { AuthService, AuthSession } from "../../services/auth.service";
import { interval, Subscription } from "rxjs";
import {NgForOf, NgIf} from "@angular/common";
import {ActionsContainerComponent} from "../../../core/actions-container/actions-container.component";
import {MatButtonModule} from "@angular/material/button";
import {RouterLink} from "@angular/router";
import {BackButtonComponent} from "../../../core/back-button/back-button.component";
import {DataPreviewComponent} from "../../../core/data-preview/data-preview.component";
import {UptimeViewComponent} from "../../../core/uptime-view/uptime-view.component";


@Component({
  selector: 'auth-user-account-details',
  templateUrl: './auth-account-details.component.html',
  standalone: true,
  imports: [
    NgIf,
    ActionsContainerComponent,
    MatButtonModule,
    RouterLink,
    BackButtonComponent,
    NgForOf,
    DataPreviewComponent,
    UptimeViewComponent
  ]
})
export class AuthAccountDetailsComponent implements OnInit, OnDestroy {

  session?: AuthSession
  sessionChanges?: Subscription
  timerChanges?: Subscription
  expiresInSeconds?: number

  constructor(readonly authService: AuthService) {}

  ngOnInit(): void {
    this.session = this.authService.getSession()
    this.invalidateUI()

    this.sessionChanges = this.authService.sessionState.subscribe({
      next: (s) => {
        this.session = s
        this.invalidateUI()
      }
    })
    this.timerChanges = interval(1000).subscribe({
      next: () => {
        this.invalidateUI()
      }
    })
  }

  ngOnDestroy(): void {
    this.sessionChanges?.unsubscribe()
    this.sessionChanges = undefined
    this.timerChanges?.unsubscribe()
    this.timerChanges = undefined
  }

  protected invalidateUI(): void {
    if (this.session) {
      const expirationAt = this.authService.getExpirationDate(this.session.identity)
      this.expiresInSeconds = (expirationAt.getTime() - new Date().getTime()) / 1000
    }
  }
}
